<template>
    <div class="d-flex align-items-center ">
      <CRow class="justify-content-center text-center col-md-12 col-12">
        <CCard
          color="white"
          text-color="dark"
          class="text-center col-md-12 col-12"
          body-wrapper>
          
          <div v-if="title != ''">
            <h5 class="mt-4">{{ title }}</h5>
            <CAlert v-if="msgError != ''" color="danger">{{ msgError}}</CAlert>
            <CAlert v-if="msgSuccess != ''" color="success">{{ msgSuccess}}</CAlert>
            <CCard  v-if="msgSuccess != ''">
              <CCardBody>
                <CRow class="justify-content-center">
                  <CCol lg="8" col="12" >
                    <img src="/img/promotegrab/banner_Prgrab.png" class="float-center mb-4" style="    width: -webkit-fill-available;" />

                  </CCol>
                  <CCol lg="12">
                      <div v-if="$i18n.locale === 'th'">
                           <p class="text-dark text-center mb-0 mt-2">คลิกเข้าสู่ระบบ เพื่อเชื่อมต่อ <img  src="/img/grabFood.svg" width="60px;" ></p>
                          <small v-html="$t('grabIntergrationDesAdd')" class="text-description text-muted "></small>
                          <a href="https://support.silompos.com/th/category/grab-x-silom-wl8k28/" target="_blank"> <small class="text-info">{{ $t('seemore') }}</small></a>
                      </div>
                      <div v-else >
                           <p class="text-dark text-center mb-0 mt-2">Click to Login for connect <img  src="/img/grabFood.svg" width="60px;" ></p>
                          <small v-html="$t('grabIntergrationDesAdd')" class="text-description text-muted "></small>
                          <a href="https://support.silompos.com/th/category/grab-x-silom-wl8k28/" target="_blank"> <small class="text-info">{{ $t('seemore') }}</small></a>
                          
                      </div>
                      <CButton  size="lg" color="success" class="text-center mt-2 "  v-on:click="goToLoginPage"  v-if="$i18n.locale === 'th'"> คลิกเพื่อเข้าสู่ระบบ</CButton>
                      <CButton  size="lg" color="success" class="text-center mt-2 "  v-on:click="goToLoginPage"  v-else> Click to Login </CButton>
                  </CCol>
                </CRow>
              </CCardBody>
            </CCard>
          </div>
          <div v-else-if="mode == 'resetPassword'">
            <h3>{{ $t('signIn') }}</h3>
            <p class="text-left font-weight-bold text-dark">{{ $t('for') }} {{ email }}</p>
            <CForm>
              <CAlert v-if="alert != ''" color="danger" :show.sync=delayAlert closeButton>{{ alert }}</CAlert>
              <CInput
                v-model="newPassword"
                type="password"
                placeholder="New password">
                <template #prepend-content>
                  <CIcon name="cil-lock-locked" />
                </template>
              </CInput>
              <CRow>
                <CCol col="12">
                  <CButton
                    @click="confirmPasswordReset"
                    block
                    color="success"
                    class="px-4"
                    :disabled="loadingButton">
                    <CSpinner v-if='loadingButton==true' color="white" size="sm" />
                    {{ $t('save') }}
                  </CButton>
                </CCol>
              </CRow>
            </CForm>
          </div>
        </CCard>
      </CRow>
    </div>
</template>
  
  <script>
  import firebase from 'firebase/app'
  
  export default {
    name: 'Login',
    data() {
      return {
        email: null,
        newPassword: null,
        title: '',
        msgError: '',
        msgSuccess: '',
        alert: '',
        delayAlert: 3,
        loadingButton: false
      }
    },
    created() {
      const mode = this.$route.query.mode
      const actionCode = this.$route.query.oobCode
      const continueUrl = this.$route.query.continueUrl
      const lang = this.$route.query.lang || 'th'        
      
      switch (mode) {
        case 'resetPassword':
          this.title = this.$t('loading')
          this.verifyPasswordResetCode()
          break;
        case 'recoverEmail':
          break;
        case 'verifyEmail':
          this.title = this.$t('verifying')
          this.handleVerifyEmail()
          break;
        default:
          break;
      }
    },
    computed: {
      mode() {
        return this.$route.query.mode
      },
      oobCode() {
        return this.$route.query.oobCode
      },
    },
    methods: {
      async checkActionCode() {
        try {
          const data = await firebase.auth().checkActionCode(this.oobCode)
        } catch (error) {
          console.log(error)
        }
      },
      async confirmPasswordReset() {
        this.alert = ''
        this.delayAlert = 3
        this.loadingButton = true
        try {
          const data = await firebase.auth().confirmPasswordReset(this.oobCode, this.newPassword)
          this.title = this.$t('passwordchanged')
          this.msgSuccess = this.$t('loginNewPass')
        } catch (error) {
          this.alert = error.message
          console.log(error)
        }
        this.loadingButton = false
      },
      async verifyPasswordResetCode() {
        try {
          const data = await firebase.auth().verifyPasswordResetCode(this.oobCode)
          this.email = data
          this.title = ''
        } catch (error) {
          this.title = this.$t('tryresetpassword')
          this.msgError = error.message
        }
      },
      goToLoginPage() {
        // this.$router.push({ name: 'Login' })
        window.location.href = 'https://dashboard.silompos.com/login/'
      },
      async handleVerifyEmail() {
        try {
          const data = await firebase.auth().applyActionCode(this.oobCode)
          this.title = this.$t('emailVeified')
          this.msgSuccess = this.$t('signinNewAcc')
        } catch (error) {
          this.title = this.$t('tryVerifiedEmail')
          this.msgError = error.message
        }
      }
    },
  }
  </script>
  